import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import { PALETTE, SIZES } from '../../../../../../src/theme';

// DEPRECATED

const ICON_OPTIONS = {
  COLORS: PALETTE,
  SIZES,
};

const StyledIcon = styled.i`
  /** COLOR */
  color: ${props => props.theme.palette[props.color]};

  /** SIZE */
  ${props => {
    switch (props.size) {
      case ICON_OPTIONS.SIZES.XXS:
        return css`
          font-size: 8px;
        `;
      case ICON_OPTIONS.SIZES.XS:
        return css`
          font-size: 9px;
        `;
      case ICON_OPTIONS.SIZES.SM:
        return css`
          font-size: 12px;
        `;
      case ICON_OPTIONS.SIZES.MD:
      default:
        return css`
          font-size: 14px;
        `;
      case ICON_OPTIONS.SIZES.LG:
        return css`
          font-size: 16px;
        `;
      case ICON_OPTIONS.SIZES.XL:
        return css`
          font-size: 20px;
        `;
      case ICON_OPTIONS.SIZES.XXL:
        return css`
          font-size: 50px;
        `;
    }
  }}
`;

const Icon = ({ className, color, icon, size, ...otherIconProps }) => {
  return (
    <StyledIcon
      className={classnames(`icon-${icon}`, className)}
      color={color}
      size={size}
      {...otherIconProps}
    />
  );
};

const iconPropTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.values(ICON_OPTIONS.COLORS)),
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(ICON_OPTIONS.SIZES)),
};
const iconDefaultProps = {
  className: undefined,
  color: ICON_OPTIONS.COLORS.NORMAL,
  size: ICON_OPTIONS.SIZES.MD,
};

Icon.propTypes = iconPropTypes;
Icon.defaultProps = iconDefaultProps;
export default Icon;
export { ICON_OPTIONS, iconPropTypes, iconDefaultProps };
